import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import React, { useState } from 'react'
import headerStyles from './styles.module.scss'
import './styles.css'

const Header = ({ siteTitle }) => {
  const [isClicked, setState] = useState(false)
  let navList = ['nav-list']
  let navListOpen = ['nav-list open']

  let lineClassOne = ['line top']
  let lineClassOneActive = ['line top active']

  let lineClassTwo = ['line middle']
  let lineClassTwoActive = ['line middle active']

  let lineClassThree = ['line bottom']
  let lineClassThreeActive = ['line bottom active']

  const toggle = () => {
    setState(!isClicked)
  }

  return (
    <header className={headerStyles.header}>
      <div className={headerStyles.title}>
        <Link to="/" className={headerStyles.titleLink}>
          {siteTitle.toUpperCase()}
        </Link>
      </div>
      <nav>
        <div className={headerStyles.toggleWrapper}>
          <div
            className={headerStyles.toggleBar}
            onClick={toggle}
            style={
              isClicked ? borderToggleBarClicked : borderToggleBarUnclicked
            }
          >
            <span
              className={isClicked ? lineClassOneActive : lineClassOne}
            ></span>
            <span
              className={isClicked ? lineClassTwoActive : lineClassTwo}
            ></span>
            <span
              className={isClicked ? lineClassThreeActive : lineClassThree}
            ></span>
          </div>
        </div>
        <ul className={isClicked ? navListOpen : navList}>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              to="/"
            >
              Home
            </Link>
          </li>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              to="/about"
            >
              About
            </Link>
          </li>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              partiallyActive={true}
              to="/portfolio"
            >
              Portfolio
            </Link>
          </li>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              partiallyActive={true}
              to="/courses"
            >
              Courses
            </Link>
          </li>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              partiallyActive={true}
              to="/consultancy"
            >
              Consultancy
            </Link>
          </li>
          <li className={headerStyles.navItem}>
            <Link
              className={headerStyles.navLink}
              activeStyle={headerActive}
              partiallyActive={true}
              to="/blog"
            >
              Blog
            </Link>
          </li>

          <li className={headerStyles.navItem}>
            <a
              href="https://calendly.com/alexjung235"
              target="blank"
              activestyle={headerActive}
              className={headerStyles.navLink}
              to="/bookmeeting"
            >
              Book a Meeting
            </a>
          </li>
        </ul>
      </nav>
    </header>
  )
}

const headerActive = {
  borderBottom: '3px solid #22225c',
}

const borderToggleBarClicked = {
  border: '1px solid white',
  borderRadius: '500px',
}

const borderToggleBarUnclicked = {
  border: 'none',
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: 'Alexander Jung',
}

export default Header
